import { useSearchParams } from 'react-router-dom'

// The training dashboard runs on the Spark (localhost:8787). A small Cloud Run
// service (spark-dash-proxy) reaches it over Tailscale and re-serves it at a public
// URL; this page embeds that in an iframe. Access is gated by a token: /train?k=<token>
// is passed through to the dashboard, which 403s without it. Bare /train shows nothing.
const DASHBOARD = 'https://spark-dash-proxy-e576vzj5oa-uc.a.run.app'

export default function Train() {
  const [params] = useSearchParams()
  const k = params.get('k')

  if (!k) {
    return (
      <div style={{ padding: '2rem 0' }}>
        <h1>Training dashboard</h1>
        <p style={{ color: 'var(--text-secondary)', marginTop: '0.75rem' }}>
          This page requires an access key. Open it as{' '}
          <code>/train?k=YOUR_KEY</code>.
        </p>
      </div>
    )
  }

  return (
    <div>
      <h1 style={{ marginBottom: '1rem' }}>
        Training — GLM-4.7-Flash autoresearch loop
      </h1>
      <iframe
        title="training-dashboard"
        src={`${DASHBOARD}/?k=${encodeURIComponent(k)}`}
        style={{
          width: '100%',
          height: 'calc(100vh - 220px)',
          minHeight: '600px',
          border: '1px solid var(--border)',
          borderRadius: '8px',
          background: '#04060a',
        }}
      />
    </div>
  )
}
